var _rect, _rect2, _rect3, _rect4, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupply(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    rx: 30,
    fill: "#EAF8FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 45,
    width: 62,
    height: 48,
    rx: 10,
    fill: "#1680D8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 33,
    width: 32,
    height: 18,
    rx: 7,
    fill: "#0E63B7"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 54,
    width: 14,
    height: 30,
    rx: 3,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 62,
    width: 30,
    height: 14,
    rx: 3,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupply);
export default __webpack_public_path__ + "static/media/supply.33f1e951fb0d07870e01afc465a525b8.svg";
export { ForwardRef as ReactComponent };